"use server";

import { parseWithZod } from "@conform-to/zod/v4";
import { redirect } from "next/navigation";

import { authErrorReply } from "@/lib/auth/errors";
import { requestOrigin } from "@/lib/auth/origin";
import { resetSchema } from "@/lib/auth/schemas";
import { getServerSupabase } from "@/lib/supabase/server";

export async function resetPasswordAction(_prev: unknown, formData: FormData) {
  const submission = parseWithZod(formData, { schema: resetSchema });
  if (submission.status !== "success") return submission.reply();

  const [supabase, origin] = await Promise.all([
    getServerSupabase(),
    requestOrigin(),
  ]);
  const { error } = await supabase.auth.resetPasswordForEmail(submission.value.email, {
    redirectTo: `${origin}/auth/callback?next=/auth/update-password`,
  });
  if (error) return submission.reply(authErrorReply(error));

  // Email deliberately omitted from URL — the interstitial copy is
  // enumeration-resistant ("if an account exists…"); echoing the email
  // would undo that protection in browser history + referer.
  redirect("/auth/reset?sent=1");
}
